export default __webpack_public_path__ + "static/media/zori_s.b08d86b2.jpg";